/*
THIS COMPONENT INCLUDING IN COMPENSATION PAGE
 ---------------------------------------------*/

import {isArrayContains} from "../../../js/functions";

let CompensationItems = (() => {
    const $urlGetItems = '/compensation_items/getItems';
    const $urlDelete = '/compensation_items/';
    const $buttonAdd = '.add-item';
    const $buttonDelete = '.delete-item';
    const $container = '#compensation-items';
    const form = '#compensation_form';
    const container = '.item-container';

    let init = () => {
        listenAdd();
        listenDelete();
    };

    /*
     |--------------------------------------------------------------------------
     | Adding new field
     |--------------------------------------------------------------------------
     */
    let listenAdd = () => {
        $(document).on('click', $buttonAdd, () => {
            updateOrderInformation();
        });
    };

    /*
     |--------------------------------------------------------------------------
     | Deleting given field
     |--------------------------------------------------------------------------
     */
    let listenDelete = () => {
        $(document).on('click', $buttonDelete, function () {
            let field = $(this).parents(container);
            let id = field.data('id');
            if (id) {
                deleteFromDb(id, field);
                return true;
            }

            deleteLocal(field);
        });
    };

    let deleteFromDb = (id, field) => {
        if (confirm('Вы уверены, что хотите удалить это поле?')) {
            $.ajax({
                url: $urlDelete + id,
                method: 'POST',
                data: {
                    _method: 'DELETE'
                }
            }).done(() => {
                field.remove();
            });
        }
    };

    let deleteLocal = (field) => {
        field.remove();
    };

    // load products list to main form using ajax
    let updateOrderInformation = function() {
        $.ajax({
            url: $urlGetItems,
            type: 'get',
            dataType: 'json',
            data: {
                compensation_products: getCompensationProducts(),
                compensation_id: getCompensationId()
            },
            success: function (data) {
                $($container).html(data.compensationItems);
            }
        });
    };

    let getCompensationProducts = () => {
        let currentOrderItems = getCurrentOrderItems();
        return $.merge(currentOrderItems, getCheckedProducts(currentOrderItems));
    };

    let getCurrentOrderItems = function() {
        return $('#compensation-items').find('.item-container').map(function () {
            return {
                id: $(this).find('.item-container__compensation_product_id').val(),
                quantity: $(this).find('.item-container__quantity').val()
            };
        }).get();
    };

    // get all checked compensation product's
    let getCheckedProducts = function(currentItems) {
        return $('.b-compensation-products-tree__checkbox:checked').map(function () {
            if (!isArrayContains('id', this.value, currentItems)) {
                return {
                    id: this.value,
                    quantity: 1
                };
            }
        }).get();
    };

    let getCompensationId = function() {
        return $(form).data('id');
    };

    return {
        init: init
    }
})();

export default CompensationItems;